module.exports = __webpack_public_path__ + "img/ad.d8be6b1b.png";